import { InvoiceStatus } from '~/store/apis/dtos/loan/loans.dto';
import { LoanType } from './loan';

export interface Invoice {
  totalAmount: string;
  sentDate: string | null;
  paidDate: string;
  dueDate: string;
  id: number;
  loanId?: number;
  amortization: string;
  prolongationFee: string;
  monthlyFee: string;
  status: InvoiceStatus;
  downloadable: boolean;
  nextSEPADDMonth: Date | null;
  lateDays?: number;
  daysBeforeDueDate?: number;
  lateFee?: string;
  amortizationOpen?: string;
  monthlyFeeOpen?: string;
  paperInvoiceFee?: string;
  reactivationFee?: string;
  feeDiscount?: string;
  latePenaltyFee?: string;
  amoFreeMonthExecuted?: boolean;
}
export interface CurrentInvoiceResponse {
  invoices: Invoice[];
  hasOverdueInvoices?: boolean;
  areAllInvoicesUpcoming?: boolean;
}

export interface LoanInvoiceData {
  loanId: number;
  invoice: Invoice;
  hasOverdueInvoices: boolean;
  areAllInvoicesUpcoming: boolean;
  contractNumber?: string;
  loanType?: LoanType;
  terminationLetterSent?: boolean;
}

export interface AllLoansCurrentInvoicesResponse {
  loanInvoices: LoanInvoiceData[];
  hasOverdueInvoices: boolean;
  areAllInvoicesUpcoming: boolean;
}

export const validCurrentInvoiceStatuses: InvoiceStatus[] = [
  'NEW',
  'OVERDUE',
  'COLLECTION',
  'PENDING',
  'UPCOMING',
];
